export default {
      id: "circle-right-arrow-usage",
      viewBox: "0 0 26 26",
      url: __webpack_public_path__ + "sprite.svg#circle-right-arrow",
      toString: function () {
        return this.url;
      }
    }